<template lang="html">
  <section class="hit-calculator-insights-settings settings">
    <header>
      <h1 class="page-header">Insights (hit calculator)</h1>
    </header>
    <div class="row">
      <div class="col-md-6">
        <div class="radio">
          <label>
            <input
              v-model="hitCalculatorInsightsVisible"
              type="radio"
              value="true"
            >
            Show insights
            <img src="/static/settings/hit-calculator-insights-visible.png">
          </label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="radio">
          <label>
            <input
              v-model="hitCalculatorInsightsVisible"
              type="radio"
              value="false"
            >
            Hide insights
            <img src="/static/settings/hit-calculator-insights-not-visible.png">
          </label>
        </div>
      </div>
    </div>
    <hr>
    <button
      class="btn btn-primary btn-lg"
      v-on:click="save()"
    >Save</button>
  </section>
</template>

<script>
export default {
  name: 'hit-calculator-insights-settings',
  data: function () {
    return {
      hitCalculatorInsightsVisible: this.$store.state.account.user.settings.hitCalculator.insightsVisible.toString(),
    };
  },
  methods: {
    save: function () {
      let self = this;
      let user = _.cloneDeep(this.$store.state.account.user);
      let newValue = this.hitCalculatorInsightsVisible === 'true' ? true : false;

      user.settings.hitCalculator.insightsVisible = newValue;
      self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
  }
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/settings';

  img {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/hit-calculator/insights.vue